import { Button, Modal } from "antd";
import { InfoCircleOutlined } from '@ant-design/icons';

interface ErrorMessageModalProps {
  open: boolean;
  title: string;
  text: string;
  handleDone: any;
  showInfoText?: boolean;
  infoText?: string;
}

const ErrorMessageModal = ({
  open,
  title,
  text,
  handleDone,
  showInfoText,
  infoText
}: ErrorMessageModalProps) => {
  return (
    <Modal
      centered
      open={open}
      closeIcon={null}
      footer={[
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          marginTop: '16px',
        }}>
          {showInfoText ? (
            <div style={{
              alignItems: 'center',
              gap: '8px',
              backgroundColor: '#EBEDFE',
              border: '1px solid #A4ADFB',
              padding: '9px 12px',
            }}>
              <InfoCircleOutlined style={{ color: '#394CF6' }} />
              <span style={{ paddingLeft: '8px' }}>{infoText}</span>
            </div>
          ) : (
            <div />
          )
          }
          <Button
            type="primary"
            onClick={handleDone}
            style={{ marginRight: 8, marginLeft: 8, marginBottom: 4 }}
          >
            Done
          </Button>
        </div >
      ]}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          minHeight: 76,
          maxHeight: 568,
          marginBottom: 24,
          marginRight: 8,
          marginLeft: 8,
          marginTop: 12,
        }}
      >
        <img
          alt="warning circle icon"
          src={require("../../../../assets/icons/warning-circle.png")}
          style={{ width: 22, height: 22, marginRight: 16 }}
        />
        <div style={{ display: "flex", flexDirection: "column", gap: 8, maxWidth: "100%", wordBreak: "break-word", width: "100%" }}>
          <p style={{ fontSize: 16, fontWeight: 700, lineHeight: "1.5rem" }}>
            {title}
          </p>
          <p style={{ fontSize: 14, fontWeight: 400, lineHeight: "1.5rem", whiteSpace: "pre-line", overflowY: "auto", maxHeight: "250px" }}>
            {text}
          </p>
        </div>
      </div>
    </Modal >
  );
};

export default ErrorMessageModal;
